"use strict";

// import Instafeed from "instafeed.js";
import Glider from "glider-js";

// import { tns } from "tiny-slider/src/tiny-slider";

const loadInstagramPhotos = (loadPhotos) => {
    new Glider(
        document.querySelector(".js-load-instagram-photos #sbi_images"),
        {
            slidesToShow: 5,
            slidesToScroll: 5,
            draggable: true,
            dots: ".dots",
        }
    );
    // var slider = tns({
    //     container: ".js-load-instagram-photos #sbi_images",
    //     items: 5,
    //     slideBy: 1,
    //     autoplay: true,
    // });
};

export default function () {
    const loadPhotos = document.querySelector(".js-load-instagram-photos");

    window.addEventListener("load", function () {
        if (loadPhotos) {
            loadInstagramPhotos(loadPhotos);
        }
    });
}
